exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".st0 {\n  fill:#C4D600;\n}\n.st1 {\n  fill:#5A6771;\n}", ""]);
